import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import { Modal } from 'react-bootstrap';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';
import AircraftModelVersionCustomItemsTab from './Elements/AircraftModelVersionCustomItemsTab';

class AircraftModelsEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      id: '',
      name: '',
      model: '',
      motor: '',
      size: '',
      class: '',
      pilots_type: '',
      use_in_planning: false,
      consider_weight: 0,
      ground_consumption: '',
      flight_consumption: '',
      fuel_capacity: '',
      engines_qty: '',
      cel_preservation_days: '',
      engine_preservation_days: '',
      fuel_type_id: '',
      fuel_unity_id: '',
      manufacturer: '',
      cost_center: '',
      // Versions, counters, engines (parity)
      version_custom_itens_modal: false,
      aircraft_model_version: '',
      aircraft_model_version_id: null,
      reference_type: null,
      counter: '',
      count_type: null,
      field_type: null,
      aircraft_model_special_counters: [],
      aircraft_model_versions: [],
      aircraft_model_versions_list: [],
      engines_list: [],
      fuel_types_list: [],
      fuel_unity_list: [],
      similar_models: [],
      similar_models_list: [],
      aircraft_model_related_id: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
    this.addAircraftSimilar = this.addAircraftSimilar.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    // versions / counters
    this.addVersion = this.addVersion.bind(this);
    this.deleteVersion = this.deleteVersion.bind(this);
    this.deleteVersionRow = this.deleteVersionRow.bind(this);
    this.addCounter = this.addCounter.bind(this);
    this.deleteCounter = this.deleteCounter.bind(this);
    this.deleteCounterRow = this.deleteCounterRow.bind(this);
    this.openEditModal = this.openEditModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleSelectReferenceTypeChange = this.handleSelectReferenceTypeChange.bind(this);
    this.handleSelectCountTypeChange = this.handleSelectCountTypeChange.bind(this);
    // engines
    this.handleEngineChange = this.handleEngineChange.bind(this);
    this.handleEngineFlightHoursChange = this.handleEngineFlightHoursChange.bind(this);
    this.addEngine = this.addEngine.bind(this);
    this.editEngine = this.editEngine.bind(this);
    this.deleteEngine = this.deleteEngine.bind(this);
    this.deleteEngineRow = this.deleteEngineRow.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/aeronave/modelo/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/aeronave/modelos');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.id,
            name: responseJson.data.name,
            model: responseJson.data.model,
            class: responseJson.data.class,
            size: responseJson.data.size,
            motor: responseJson.data.motor,
            use_in_planning: responseJson.data.use_in_planning,
            consider_weight: responseJson.data.consider_weight,
            fuel_type_id: responseJson.data.fuel_type_id,
            fuel_unity_id: responseJson.data.fuel_unity_id,
            manufacturer: responseJson.data.manufacturer,
            cost_center: responseJson.data.cost_center,
            pilots_type: responseJson.data.pilots_type,
            flight_consumption: responseJson.data.flight_consumption,
            ground_consumption: responseJson.data.ground_consumption,
            fuel_capacity: responseJson.data.fuel_capacity,
            engines_qty: responseJson.data.engines_qty,
            cel_preservation_days: responseJson.data.cel_preservation_days,
            engine_preservation_days: responseJson.data.engine_preservation_days,
          });
        }
      }).then(() => {
      var url = config.get('api') + '/tipo/combustivel/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({ fuel_types_list: responseJson.data });
        }
      }).then(() => {
      var url = config.get('api') + '/unidade/combustivel/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({ fuel_unity_list: responseJson.data });
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/similares/lista/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({similar_models_list: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/similares/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({similar_models: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/motores/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({ engines_list: responseJson.data });
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/versoes/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({ aircraft_model_versions: responseJson.data });
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/versoes/lista/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({ aircraft_model_versions_list: responseJson.data });
        }
      }).then(() => {
      var url = config.get('api') + '/aeronave/modelo/contadores/' + self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({ aircraft_model_special_counters: responseJson.data });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */}); /* Engines */}); /* Versions */}); /* Versions select */}); /* Counters */}); /* Lista de tipos de combustível */}); /* Lista de unidades de combustível */}); /* Lista de modelos de aeronave */}); /* Modelos similares relacionados */
    });
  }

  openEditModal(id) {
    this.setState({ aircraft_model_version_id: id, version_custom_itens_modal: true });
  }

  closeModal() {
    this.setState({ aircraft_model_version_id: '', version_custom_itens_modal: false });
  }

  handleSelectReferenceTypeChange(name, event) {
    var change = {};
    if (event == null) { change[name] = null; } else { change[name] = event.value; }
    this.setState(change);
    this.setState({ aircraft_model_version_id: null });
  }

  handleSelectCountTypeChange(name, event) {
    var change = {};
    if (event == null) { change[name] = null; } else { change[name] = event.value; }
    this.setState(change);
    if (event && event.value === 'manual') { this.setState({ field_type: null }); } else { this.setState({ field_type: 'time' }); }
  }

  addVersion(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = { aircraft_model_id: this.state.id, version: this.state.aircraft_model_version };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave/modelo/versao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({ aircraft_model_version: '' });
          self.loadData();
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      });
    });
  }

  deleteVersion(event) {
    var aircraft_model_version_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa versão?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var self = this; var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aeronave/modelo/versao/' + aircraft_model_version_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') { self.deleteVersionRow(aircraft_model_version_id); self.loadData(); }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        });
      });
    }
  }

  deleteVersionRow(aircraft_model_version_id) {
    var data = this.state.aircraft_model_versions;
    data.map(function(dado, index){ if (dado.id == aircraft_model_version_id) { data.splice(index, 1); } });
    this.setState({ aircraft_model_versions: data });
  }

  addCounter(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = { aircraft_model_id: this.state.id, aircraft_model_version_id: this.state.aircraft_model_version_id, reference_type: this.state.reference_type, counter: this.state.counter, count_type: this.state.count_type, field_type: this.state.field_type };
    var self = this; var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave/modelo/contador', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') { var data_temp = self.state.aircraft_model_special_counters; data_temp.push(responseJson.data); self.setState({ aircraft_model_special_counters: data_temp }); self.loadData(); }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      });
    });
  }

  deleteCounter(event) {
    var aircraft_model_special_counter_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse contador?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var self = this; var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aeronave/modelo/contador/' + aircraft_model_special_counter_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') { self.deleteCounterRow(aircraft_model_special_counter_id); self.loadData(); }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        });
      });
    }
  }

  deleteCounterRow(aircraft_model_special_counter_id) {
    var data = this.state.aircraft_model_special_counters;
    data.map(function(dado, index){ if (dado.id == aircraft_model_special_counter_id) { data.splice(index, 1); } });
    this.setState({ aircraft_model_special_counters: data });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      model: this.state.model,
      motor: this.state.motor,
      size: this.state.size,
      class: this.state.class,
      use_in_planning: this.state.use_in_planning,
      fuel_type_id: this.state.fuel_type_id,
      fuel_unity_id: this.state.fuel_unity_id,
      manufacturer: this.state.manufacturer,
      cost_center: this.state.cost_center,
      pilots_type: this.state.pilots_type,
      ground_consumption: this.state.ground_consumption,
      flight_consumption: this.state.flight_consumption,
      fuel_capacity: this.state.fuel_capacity,
      engines_qty: this.state.engines_qty,
      cel_preservation_days: this.state.cel_preservation_days,
      engine_preservation_days: this.state.engine_preservation_days,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave/modelo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Engines helpers (parity with SIGTRIP)
  handleEngineChange(engineId, fieldName, event) {
    const value = event.target.value;
    this.setState((prevState) => {
      const updated = prevState.engines_list.map((e) => (e.id === engineId ? { ...e, [fieldName]: value } : e));
      return { engines_list: updated };
    });
  }

  handleEngineFlightHoursChange(engineId, fieldName, event) {
    const value = event.target.value;
    this.setState((prevState) => {
      const updated = prevState.engines_list.map((engine) => {
        if (engine.id === engineId) {
          return { ...engine, [fieldName]: value, [`${fieldName}_str`]: value };
        }
        return engine;
      });
      return { engines_list: updated };
    });
  }

  validateFlightHours(value) {
    const hourPattern = /^\d{1,6}:[0-5][0-9]$/;
    if (!hourPattern.test(value) && value !== '' && value !== null && value !== undefined) {
      this.handleAlert('Os campos de horas devem estar no formato HH:MM, com até 6 dígitos para as horas e minutos entre 00 e 59.', 'error', 'open');
      return false;
    }
    return true;
  }

  addEngine(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    const datasave = {
      aircraft_model_id: this.state.id,
      part_number: this.state.part_number,
      serial_number: this.state.serial_number,
      initial_flight_hours: this.state.initial_flight_hours,
      actual_flight_hours: this.state.actual_flight_hours,
    };
    const self = this;
    const header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function (value) {
      fetch(config.get('api') + '/aeronave/modelo/motor', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) })
        .then((r) => r.json())
        .catch((e) => { console.error(e); })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            const data_temp = self.state.engines_list;
            data_temp.push(responseJson.data);
            self.setState({ engines_list: data_temp });
            self.loadData();
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        });
    });
  }

  editEngine(engine) {
    this.handleAlert('', '', 'open');
    const datasave = {
      id: engine.id,
      aircraft_model_id: engine.aircraft_model_id,
      part_number: engine.part_number,
      serial_number: engine.serial_number,
      initial_flight_hours: engine.initial_flight_hours_str,
      actual_flight_hours: engine.actual_flight_hours_str,
    };
    const self = this;
    const header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function (value) {
      fetch(config.get('api') + '/aeronave/modelo/motor', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) })
        .then((r) => r.json())
        .catch((e) => { console.error(e); })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.loadData();
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        });
    });
  }

  deleteEngine(event) {
    const id = event.currentTarget.value;
    if (window.confirm('Tem certeza que gostaria de deletar esse motor?')) {
      this.handleAlert('', '', 'open');
      const self = this; const header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(config.get('api') + '/aeronave/modelo/motor/' + id, { method: 'DELETE', mode: 'cors', headers: value })
          .then((r) => r.json())
          .catch((e) => { console.error(e); })
          .then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') { self.deleteEngineRow(id); self.loadData(); }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          });
      });
    }
  }

  deleteEngineRow(id) {
    const data = this.state.engines_list;
    data.map(function (dado, index) { if (dado.id == id) { data.splice(index, 1); } });
    this.setState({ engines_list: data });
  }

  addAircraftSimilar(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      aircraft_model_id: this.state.id,
      aircraft_model_related_id: this.state.aircraft_model_related_id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aeronave/modelo/similar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var data_temp = self.state.similar_models;
          data_temp.push(responseJson.data);
          self.setState({similar_models: data_temp});
          self.loadData();
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete (event) {
    var aircraft_similar_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.ModelosAeronaves.EditarModelosAeronaves.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aeronave/modelo/similar/' + aircraft_similar_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(aircraft_similar_id);
            self.loadData();
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  deleteRow(aircraft_similar_id) {
    var data = this.state.similar_models;
    data.map(function(dado, index){
      if (dado.id == aircraft_similar_id) {
        data.splice(index, 1);
      }
    });
    this.setState({similar_models: data});
  }
  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.ModelosAeronaves.EditarModelosAeronaves.titulo}</h3>
      <Link to="/aeronave/modelos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.NomeAeronave} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.Modelo}:</label>
              <input type="text" name="model" className="form-control" placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.ModeloAeronave} value={this.state.model} onChange={this.handleChange.bind(this, 'model')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.Classe}:</label>
              <Select
                className="form-field-name"
                name="class"
                value={this.state.class}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.SelecioneClasse}
                onChange={this.handleSelectChange.bind(this, 'class')}
                options={[
                  {value: "Avião", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesClasses.Aviao},
                  {value: "Helicóptero", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesClasses.Helicoptero},
                ]}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.Porte}:</label>
              <Select
                className="form-field-name"
                name="size"
                value={this.state.size}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.SelecionePorte}
                onChange={this.handleSelectChange.bind(this, 'size')}
                options={[
                  {value: "PP", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesPorte.Pequeno},
                  {value: "MP", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesPorte.Medio},
                  {value: "SMP", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesPorte.SuperMedio },
                  {value: "GP", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesPorte.Grande},
                ]}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.UnidadeCombustivel}:</label>
              <Select
                className="form-field-name"
                name="fuel_unity_id"
                value={this.state.fuel_unity_id}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.SelecioneUnidadeCombustivel}
                onChange={this.handleSelectChange.bind(this, 'fuel_unity_id')}
                options={this.state.fuel_unity_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.TipoCombustivel}:</label>
              <Select
                className="form-field-name"
                name="fuel_type_id"
                value={this.state.fuel_type_id}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.SelecioneTipoCombustivel}
                onChange={this.handleSelectChange.bind(this, 'fuel_type_id')}
                options={this.state.fuel_types_list}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.Motorizacao}:</label>
              <Select
                className="form-field-name"
                name="motor"
                value={this.state.motor}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.SelecioneMotorizacao}
                onChange={this.handleSelectChange.bind(this, 'motor')}
                options={[
                  {value: "MULTI", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesMotorizacao.Multimotor},
                  {value: "MONO", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesMotorizacao.Monomotor},
                ]}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.TipoTripulacao}:</label>
              <Select
                className="form-field-name"
                name="pilots_type"
                value={this.state.pilots_type}
                searchable={true}
                placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.SelecioneTripulacao}
                onChange={this.handleSelectChange.bind(this, 'pilots_type')}
                options={[
                  {value: "Dual pilot", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesTipoTripulacao.DualPilot},
                  {value: "Single pilot", label: this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.opcoesTipoTripulacao.SinglePilot},
                ]}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.Fabricante}:</label>
              <input type="text" name="manufacturer" className="form-control" placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.placeholder.FabricanteAeronave} value={this.state.manufacturer} onChange={this.handleChange.bind(this, 'manufacturer')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.ConsumoHoraSolo}:</label>
              <input type="text" placeholder="" className="form-control" name="ground_consumption" value={this.state.ground_consumption} onChange={this.handleChange.bind(this, 'ground_consumption')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.ConsumoHoraVoo}:</label>
              <input type="text" placeholder="" className="form-control" name="flight_consumption" value={this.state.flight_consumption} onChange={this.handleChange.bind(this, 'flight_consumption')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.CapacidadeDeCombustível}:</label>
              <input type="text" placeholder="" className="form-control" name="fuel_capacity" value={this.state.fuel_capacity} onChange={this.handleChange.bind(this, 'fuel_capacity')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.ModelosAeronaves.EditarModelosAeronaves.formulario.botaoSalvarEdicao}</button>
          </div>
        </div>
      </form>
      <div className="clearfix"></div>
      <hr/>
      <h4>{this.locale.ModelosAeronaves.EditarModelosAeronaves.versoes.titulo}</h4>
      <hr/>

      <table className="table">
        <thead>
          <tr>
            <th>#</th>
            <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.versoes.Versao}</th>
            <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.versoes.acoes}</th>
          </tr>
        </thead>
        <tbody id="frotas">
          {Object.keys(self.state.aircraft_model_versions).map(function(k) {
            return (
              <tr key={self.state.aircraft_model_versions[k].id}>
                <td>{self.state.aircraft_model_versions[k].id}</td>
                <td>{self.state.aircraft_model_versions[k].version}</td>
                <td>
                  <button type="button" onClick={() => self.openEditModal(self.state.aircraft_model_versions[k].id)} className="btn btn-primary button-inline btn-sm"><i className="fa fa-fw fa-edit"></i></button>
                  <button type="button" className="btn btn-sm button-inline btn-danger" value={self.state.aircraft_model_versions[k].id} onClick={self.deleteVersion}><i className="fa fa-fw fa-trash"></i></button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <form onSubmit={this.addVersion}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.versoes.Versao}:</label>
              <input type="text" className="form-control" value={this.state.aircraft_model_version} onChange={this.handleChange.bind(this, 'aircraft_model_version')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <button type={'submit'} className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.ModelosAeronaves.EditarModelosAeronaves.versoes.formulario.AdicionarVersao}</button>
            </div>
          </div>
        </div>
      </form>

      <div className="clearfix"></div>
      <hr/>
      <h4>{this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.titulo}</h4>
      <hr/>

      <table className="table">
        <thead>
          <tr>
            <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.Contador}</th>
            <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.Versao}</th>
            <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.Referencia}</th>
            <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.TipoContagem}</th>
            <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.TipoCampo}</th>
            <th></th>
          </tr>
        </thead>
        <tbody id="frotas">
          {Object.keys(self.state.aircraft_model_special_counters).map(function(k) {
            return (
              <tr key={self.state.aircraft_model_special_counters[k].id}>
                <td>{self.state.aircraft_model_special_counters[k].counter}</td>
                <td>{self.state.aircraft_model_special_counters[k].version}</td>
                <td>{self.state.aircraft_model_special_counters[k].reference_type_str}</td>
                <td>{self.state.aircraft_model_special_counters[k].count_type_str}</td>
                <td>{self.state.aircraft_model_special_counters[k].field_type_str}</td>
                <td>
                  <button className="btn btn-sm btn-danger" value={self.state.aircraft_model_special_counters[k].id} onClick={self.deleteCounter}><i className="fa fa-fw fa-trash"></i></button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <form onSubmit={this.addCounter}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.Referencia}:</label>
              <Select className="form-field-name" name="reference_type" value={this.state.reference_type} searchable={true} placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.placeholder.SelecionarReferencia} onChange={this.handleSelectReferenceTypeChange.bind(this, 'reference_type')} options={[
                {value: 'model', label: this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.options.Referencia.Modelo},
                {value: 'version', label: this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.options.Referencia.Versao},
              ]} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.Versao}:</label>
              <Select className="form-field-name" name="aircraft_model_version_id" value={this.state.aircraft_model_version_id} searchable={true} placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.placeholder.SelecionarVersao} onChange={this.handleSelectChange.bind(this, 'aircraft_model_version_id')} options={this.state.aircraft_model_versions_list} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.TipoContagem}:</label>
              <Select className="form-field-name" name="count_type" value={this.state.count_type} searchable={true} placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.placeholder.SelecionarTipoContagem} onChange={this.handleSelectCountTypeChange.bind(this, 'count_type')} options={[
                {value: 'start_shutdown', label: this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.options.TipoContagem.PartidaCorte},
                {value: 'takeoff_landing', label: this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.options.TipoContagem.DecolagemPouso},
                {value: 'manual', label: this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.options.TipoContagem.Manual},
              ]} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.Contador}:</label>
              <input type="text" name="counter" className="form-control" value={this.state.counter} onChange={this.handleChange.bind(this, 'counter')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.TipoCampo}:</label>
              <Select className="form-field-name" name="field_type" value={this.state.field_type} searchable={true} placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.placeholder.SelecionarTipoCampo} onChange={this.handleSelectChange.bind(this, 'field_type')} options={[
                {value: 'integer', label: this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.options.TipoCampo.Inteiro},
                {value: 'time', label: this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.options.TipoCampo.Horario},
                {value: 'decimal', label: this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.options.TipoCampo.Decimal},
              ]} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <button type={'submit'} className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.ModelosAeronaves.EditarModelosAeronaves.contadores.formulario.AdicionarContador}</button>
            </div>
          </div>
        </div>
      </form>

      <div className="clearfix"></div>
      <hr/>
      <h4>{this.locale.ModelosAeronaves.EditarModelosAeronaves.motores.titulo}</h4>
      <hr/>

      <table className="table">
        <thead>
          <tr>
            <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.motores.Aeronave}</th>
            <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.motores.PartNumber}</th>
            <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.motores.SerialNumber}</th>
            <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.motores.HorasIniciais}</th>
            <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.motores.HorasAtuais}</th>
            <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.motores.acoes}</th>
          </tr>
        </thead>
        <tbody id="motores">
          {Object.keys(self.state.engines_list).map(function (k) {
            var engine = self.state.engines_list[k];
            return (
              <tr key={engine.id}>
                <td>
                  <input type="text" name="aircraft_engine" className="form-control" value={engine.aircraft_engine} disabled />
                </td>
                <td>
                  <input type="text" name="part_number" className="form-control" value={engine.part_number} onChange={(e) => self.handleEngineChange(engine.id, 'part_number', e)} required />
                </td>
                <td>
                  <input type="text" name="serial_number" className="form-control" value={engine.serial_number} onChange={(e) => self.handleEngineChange(engine.id, 'serial_number', e)} required />
                </td>
                <td>
                  <input type="text" name="initial_flight_hours" className="form-control" value={engine.initial_flight_hours_str} onChange={(e) => self.handleEngineFlightHoursChange(engine.id, 'initial_flight_hours', e)} onBlur={() => self.validateFlightHours(engine.initial_flight_hours_str)} placeholder="00000:00" required />
                </td>
                <td>
                  <input type="text" name="actual_flight_hours" className="form-control" value={engine.actual_flight_hours_str} onChange={(e) => self.handleEngineFlightHoursChange(engine.id, 'actual_flight_hours', e)} onBlur={() => self.validateFlightHours(engine.actual_flight_hours_str)} placeholder="00000:00" required />
                </td>
                <td>
                  <button className="btn btn-sm btn-primary button-inline" value={engine.id} onClick={() => self.editEngine(engine)}>
                    <i className="fa fa-fw fa-save"></i>
                  </button>
                  <button className="btn btn-sm btn-danger button-inline" value={engine.id} onClick={self.deleteEngine}>
                    <i className="fa fa-fw fa-trash"></i>
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <form onSubmit={this.addEngine}>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.motores.PartNumber}:</label>
              <input type="text" name="part_number" className="form-control" placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.motores.PartNumber} value={this.state.part_number} onChange={this.handleChange.bind(this, 'part_number')} required />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.motores.SerialNumber}:</label>
              <input type="text" name="serial_number" className="form-control" placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.motores.SerialNumber} value={this.state.serial_number} onChange={this.handleChange.bind(this, 'serial_number')} required />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.motores.HorasIniciais}:</label>
              <input type="text" name="initial_flight_hours" className="form-control" value={this.state.initial_flight_hours} onChange={this.handleChange.bind(this, 'initial_flight_hours')} onBlur={() => this.validateFlightHours(this.state.initial_flight_hours)} placeholder="00000:00" required />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.motores.HorasAtuais}:</label>
              <input type="text" name="actual_flight_hours" className="form-control" value={this.state.actual_flight_hours} onChange={this.handleChange.bind(this, 'actual_flight_hours')} onBlur={() => this.validateFlightHours(this.state.actual_flight_hours)} placeholder="00000:00" required />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <button type="submit" className="btn btn-primary btn-inline btn-block">
                <i className="fa fa-fw fa-save"></i> {this.locale.ModelosAeronaves.EditarModelosAeronaves.motores.formulario.AdicionarMotor}
              </button>
            </div>
          </div>
        </div>
      </form>
      {/* Modelos similares */}
      <hr/>
      <h3>{this.locale.ModelosAeronaves.EditarModelosAeronaves.tabela.titulo}</h3>
      <hr/>
      <form onSubmit={this.addAircraftSimilar}>
        <div className="form-group">
          <label>{this.locale.ModelosAeronaves.EditarModelosAeronaves.tabela.formulario.AdicionarModelo}:</label>
          <Select
            className="form-field-name"
            name="aircraft_model_related_id"
            value={this.state.aircraft_model_related_id}
            searchable={true}
            placeholder={this.locale.ModelosAeronaves.EditarModelosAeronaves.tabela.formulario.placeholder.SelecionarModeloSimilar}
            onChange={this.handleSelectChange.bind(this, 'aircraft_model_related_id')}
            options={this.state.similar_models_list}
          />
        </div>
        <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.ModelosAeronaves.EditarModelosAeronaves.tabela.formulario.botaoAdicionarSimilar}</button>
      </form>
      <hr/>
      <table className="table">
        <thead>
          <tr>
            <th>
              #
            </th>
            <th>
              {this.locale.ModelosAeronaves.EditarModelosAeronaves.tabela.modelo}
            </th>
            <th>{this.locale.ModelosAeronaves.EditarModelosAeronaves.tabela.acoes}</th>
          </tr>
        </thead>
        <tbody id="frotas">
          {Object.keys(self.state.similar_models).map(function(k) {
            return (
              <tr key={self.state.similar_models[k].id}>
                <td>
                  {self.state.similar_models[k].id}
                </td>
                <td>
                  {self.state.similar_models[k].model}
                </td>
                <td>
                  <button className="btn btn-sm btn-danger" value={self.state.similar_models[k].id} onClick={self.delete}>
                    <i className="fa fa-fw fa-trash"></i>
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Modal show={this.state.version_custom_itens_modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
        <Modal.Header>
          <h4 className="pull-left">{this.locale.ModelosAeronaves.EditarModelosAeronaves.modalItensPersonalizados.titulo}</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={() => this.closeModal()}><i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <AircraftModelVersionCustomItemsTab
            handleAlert={this.handleAlert}
            handleMessage={this.handleMessage}
            updateData={this.loadData}
            aircraft_model_id={this.state.id}
            aircraft_model_version_id={this.state.aircraft_model_version_id}
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={() => this.closeModal()}><i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </div>
  </div>
</div>
    );
  }
}

export default AircraftModelsEdit;



// WEBPACK FOOTER //
// ./src/Components/AircraftModels/AircraftModelsEdit.js